import { useSelector } from "react-redux";

const useFeatureFlag = (flag) => {
    const users = useSelector((state) => state.users);
    return users?.user?.subscription_meta_data?.features_flags.includes(flag);
};

export default useFeatureFlag;
